import { replaceUrlsWithHtmlElements } from "@/helpers/textHelper";

export function replaceUndefinedOrNull(key, value) {
    if (value === null || value === undefined) {
        return undefined;
    }
    return value;
}

export function dataWithoutEmptyValues(argTrainingScore) {
    const trainingScore = JSON.stringify(argTrainingScore || {}, replaceUndefinedOrNull);
    return JSON.parse(trainingScore);
}

export function randomHexColorCode() {
    const n = (Math.random() * 0xfffff * 1000000).toString(16);
    return '#' + n.slice(0, 6);
}

export function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function standardDeviation(arr) {

    // Creating the mean with Array.reduce
    let mean = arr.reduce((acc, curr) => {
        return acc + curr
    }, 0) / arr.length;

    // Assigning (value - mean) ^ 2 to
    // every array item
    arr = arr.map((k) => {
        return (k - mean) ** 2
    });

    // Calculating the sum of updated array
    let sum = arr.reduce((acc, curr) => acc + curr, 0);

    // Calculating the variance
    let variance = sum / arr.length

    // Returning the standard deviation
    return Math.sqrt(sum / arr.length)
}

export function truncateTextBySpaceIndex(text, charactersLimit) {
    if (!text) return '';

    if (text.length > charactersLimit) {
        const trimmedText = text.substring(0, charactersLimit - 3);
        const lastSpaceIndex = trimmedText.lastIndexOf(' ');

        if (lastSpaceIndex > 0) {
            text = trimmedText.substring(0, lastSpaceIndex) + '...';

        } else {
            // No spaces found before the limit — fallback to original cut
            text = trimmedText + '...';
        }
    }
    return replaceUrlsWithHtmlElements(text);
}
